import { render, staticRenderFns } from "./ChatHistoryList.vue?vue&type=template&id=25565e39"
import script from "./ChatHistoryList.vue?vue&type=script&lang=js"
export * from "./ChatHistoryList.vue?vue&type=script&lang=js"
import style0 from "./ChatHistoryList.vue?vue&type=style&index=0&id=25565e39&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports